
    import { mapState, mapGetters } from 'vuex';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { faClock as farClock } from '@fortawesome/pro-regular-svg-icons/faClock';
    import { faShapes as farShapes } from '@fortawesome/pro-regular-svg-icons/faShapes';
    import { faUniversalAccess as farUniversalAccess } from '@fortawesome/pro-regular-svg-icons/faUniversalAccess';
    import { faFileSignature as farFileSignature } from '@fortawesome/pro-regular-svg-icons/faFileSignature';
    import { faBriefcase as farBriefcase } from '@fortawesome/pro-regular-svg-icons/faBriefcase';
    import { faBusinessTime as farBusinessTime } from '@fortawesome/pro-regular-svg-icons/faBusinessTime';
    import { faLayerGroup as farLayerGroup } from '@fortawesome/pro-regular-svg-icons/faLayerGroup';
    import { faIndustryAlt as farIndustryAlt } from '@fortawesome/pro-regular-svg-icons/faIndustryAlt';
    import { faChartPieAlt as farChartPieAlt } from '@fortawesome/pro-regular-svg-icons/faChartPieAlt';
    import { faUserGraduate as farUserGraduate } from '@fortawesome/pro-regular-svg-icons/faUserGraduate';
    import { faTasks as farTasks } from '@fortawesome/pro-regular-svg-icons/faTasks';
    import { faGlobe as farGlobe } from '@fortawesome/pro-regular-svg-icons/faGlobe';
    import { faUsers as farUsers } from '@fortawesome/pro-regular-svg-icons/faUsers';
    import { faQuestionCircle as farQuestionCircle } from '@fortawesome/pro-regular-svg-icons/faQuestionCircle';

    import { faFlag as fasFlag } from '@fortawesome/pro-solid-svg-icons/faFlag';

    export default {
        name: 'JobViewJobDetails',

        components: {
            FontAwesomeIcon,
        },

        data() {
            return {
                icons: {
                    fasFlag,
                    farClock,
                    farShapes,
                    farUniversalAccess,
                    farFileSignature,
                    farBriefcase,
                    farBusinessTime,
                    farLayerGroup,
                    farIndustryAlt,
                    farChartPieAlt,
                    farUserGraduate,
                    farTasks,
                    farGlobe,
                    farUsers,
                    farQuestionCircle,
                },
            };
        },

        computed: {
            ...mapState({
                $_job: state => state.job.job,
            }),

            ...mapGetters('job', {
                $_postedAt: 'postedAt',
                $_postedAtLabel: 'postedAtLabel',
                $_expiresAt: 'expiresAt',
                $_expiringAt: 'expiringAt',
                $_contractType: 'contractTypeLabel',
                $_jobTypeLabel: 'jobTypeLabel',
                $_pay: 'pay',
                $_payLabel: 'payLabel',
                $_showPay: 'showPay',
                $_jobModeLabel: 'jobModeLabel',
                $_categoryLabel: 'categoryLabel',
                $_occupationLabel: 'occupationLabel',
                $_careerLevelLabel: 'careerLevelLabel',
                $_industryLabel: 'industryLabel',
                $_sectorLabel: 'sectorLabel',
                $_educationLevelLabel: 'educationLevelLabel',
                $_languagesLabel: 'languagesLabel',
                $_companySize: 'companySize',
                $_workAuthorisationLabel: 'workAuthorisationLabel',
            }),

            itemsFiltered() {
                if (this.$_job.is_expired) {
                    return this.items.filter((i) => {
                        return i.text && i.label !== 'Expiring date';
                    });
                }

                return this.items.filter((i) => {
                    return i.text;
                });
            },

            items() {
                return [
                    {
                        icon: this.icons.fasFlag,
                        label: 'Expired',
                        text: this.$_expiresAt,
                        class: 'is_expired',
                    },
                    {
                        icon: this.icons.fasFlag,
                        label: 'Expiring date',
                        text: this.$_expiringAt,
                    },
                    {
                        icon: this.icons.farClock,
                        label: this.$_postedAtLabel,
                        text: this.$_postedAt,
                    },
                    {
                        icon: this.icons.farShapes,
                        label: 'Category',
                        text: this.$_categoryLabel,
                    },
                    {
                        icon: this.icons.farUniversalAccess,
                        label: 'Occupation',
                        text: this.$_occupationLabel,
                    },
                    {
                        icon: this.icons.farFileSignature,
                        label: 'Contract type',
                        text: this.$_contractType,
                    },
                    {
                        icon: this.icons.farBriefcase,
                        label: 'Work type',
                        text: this.$_jobTypeLabel,
                    },
                    {
                        icon: this.icons.farBusinessTime,
                        label: 'Job mode',
                        text: this.$_jobModeLabel,
                    },
                    {
                        icon: this.icons.farLayerGroup,
                        label: 'Career level',
                        text: this.$_careerLevelLabel,
                    },
                    {
                        icon: this.icons.farIndustryAlt,
                        label: 'Industry',
                        text: this.$_industryLabel,
                    },
                    {
                        icon: this.icons.farChartPieAlt,
                        label: 'Sector',
                        text: this.$_sectorLabel,
                    },
                    {
                        icon: this.icons.farUserGraduate,
                        label: 'Desired education level',
                        text: this.$_educationLevelLabel,
                    },
                    {
                        icon: this.icons.farTasks,
                        label: 'Work Authorisation',
                        text: this.$_workAuthorisationLabel,
                    },
                    {
                        icon: this.icons.farGlobe,
                        label: 'Language',
                        text: this.$_languagesLabel,
                    },
                    {
                        icon: this.icons.farUsers,
                        label: 'Company size',
                        text: this.$_companySize,
                    },
                ];
            },
        },

        methods: {},
    };
